module.exports = __webpack_public_path__ + "images/448a37e070e3c5e6e2bc1ef8dabf9613f0d67acc83077e91946adaac2c6c7174.svg";